module.exports = __webpack_public_path__ + "img/dust.b5b1f832.png";